import { render, staticRenderFns } from "./oweFeeCallableList.vue?vue&type=template&id=ece42a48&scoped=true"
import script from "./oweFeeCallableList.vue?vue&type=script&lang=js"
export * from "./oweFeeCallableList.vue?vue&type=script&lang=js"
import style0 from "./oweFeeCallableList.vue?vue&type=style&index=0&id=ece42a48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece42a48",
  null
  
)

export default component.exports